import * as tslib_1 from "tslib";
import { EventEmitter, OnChanges, OnInit, SimpleChanges, } from '@angular/core';
import { Setting, } from '@app-state';
import { NugetType, } from '@models';
import { IGridSource, ODataGridComponent, } from '@pages/generics/grid';
import { CommonNugetService, FileDownloadService, MapperService, ModalService, } from '@services';
import { forkJoin, ReplaySubject, } from 'rxjs';
import { distinctUntilChanged, map, switchMap, takeUntil, } from 'rxjs/operators';
var NugetVersionSource = /** @class */ (function () {
    function NugetVersionSource() {
    }
    Object.defineProperty(NugetVersionSource.prototype, "mapper", {
        get: function () {
            return MapperService.packageMap;
        },
        enumerable: true,
        configurable: true
    });
    NugetVersionSource.prototype.get = function (qo) {
        return this.service.getVersions(this.packageId, qo)
            .pipe(map(function (res) {
            res.data = res.data
                .map(function (pkg) { return (tslib_1.__assign({}, pkg, { id: pkg.key })); });
            return res;
        }));
    };
    return NugetVersionSource;
}());
export { NugetVersionSource };
var NugetVersionsGridComponent = /** @class */ (function (_super) {
    tslib_1.__extends(NugetVersionsGridComponent, _super);
    function NugetVersionsGridComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.NugetType = NugetType;
        _this.close = new EventEmitter();
        _this.showInformation = new EventEmitter();
        _this.showReleaseNotes = new EventEmitter();
        _this.latestVersions = new EventEmitter();
        _this._modalService = _this._injector.get(ModalService);
        _this._downloadService = _this._injector.get(FileDownloadService);
        _this._commonNugetService = _this._injector.get(CommonNugetService);
        _this._deletePermission$ = new ReplaySubject(1);
        return _this;
    }
    Object.defineProperty(NugetVersionsGridComponent.prototype, "allowDelete", {
        get: function () {
            return this._grid.selectionManager.selected.every(function (process) { return !process.isActive; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NugetVersionsGridComponent.prototype, "isRemoveAllEnabled", {
        get: function () {
            return this._grid.dataManager.some(function (process) { return !process.isActive; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NugetVersionsGridComponent.prototype, "showDeleteButton", {
        get: function () {
            if (this._appState.user.authState === 1 /* LoggedInAsTenant */ &&
                this.type === NugetType.Libraries &&
                this._appState.settings.get(Setting.librariesUseSharedFeed)) {
                return false;
            }
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NugetVersionsGridComponent.prototype, "isDownloadEnabled", {
        get: function () {
            return this._commonNugetService.isNugetDownloadEnabled(this.type);
        },
        enumerable: true,
        configurable: true
    });
    NugetVersionsGridComponent.prototype.ngOnInit = function () {
        var _this = this;
        var svc = this._service;
        svc.packageId = this.packageId;
        svc.service = this.nugetService;
        this.data$.pipe(takeUntil(this._destroyed$)).subscribe(function (data) {
            _this.latestVersions.emit(data);
            _this.latestVersions.complete();
        });
        this.isDeletePermissionGranted$ = this._deletePermission$
            .pipe(distinctUntilChanged(), switchMap(function () { return _this._appState.user.permissions.isGranted(_this.deletePermission); }));
    };
    NugetVersionsGridComponent.prototype.ngOnChanges = function (changes) {
        if (changes.deletePermission) {
            this._deletePermission$.next(changes.deletePermission.currentValue);
        }
    };
    NugetVersionsGridComponent.prototype.downloadLink = function (entry) {
        return this.nugetService.downloadLink(entry);
    };
    NugetVersionsGridComponent.prototype.downloadPackage = function (event, entry) {
        event.preventDefault();
        this._downloadService.download(this.nugetService.downloadLink(entry));
    };
    NugetVersionsGridComponent.prototype.onDeleteInactive = function () {
        var _this = this;
        var promptMessage = this._translate.instant('package_versions_modal_remove_inactive_message');
        this._modalService.onConfirm(null, function () {
            _this.nugetService.delete(_this.packageId).subscribe(function () {
                _this.close.emit(true);
            });
        }, function () { }, promptMessage);
    };
    NugetVersionsGridComponent.prototype.onDeleteVersion = function () {
        var _this = this;
        var promptMessage = this.type === NugetType.Libraries ?
            this._translate.instant('package_versions_modal_remove_selected_libraries_message') :
            this._translate.instant('package_versions_modal_remove_selected_message');
        this._modalService.onConfirm(null, function () {
            var selectedKeys = _this._grid.selectionManager.selected.map(function (r) { return r.key; });
            var deleteSelectedKeysObservables = selectedKeys.map(function (key) { return _this.nugetService.delete(key); });
            forkJoin(deleteSelectedKeysObservables)
                .subscribe(function () {
                _this.close.emit(true);
            });
        }, function () { }, promptMessage);
    };
    NugetVersionsGridComponent.prototype.onClose = function () {
        if (this._grid.dataManager.length === 0) {
            this.close.emit(true);
        }
        else {
            this.close.emit();
        }
    };
    return NugetVersionsGridComponent;
}(ODataGridComponent));
export { NugetVersionsGridComponent };
